export default __webpack_public_path__ + "static/media/noterlogo.67e5c728.png";